import { Toasts } from '@fourthwall/components'
import type { CreateWelcomePostsPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { errorMessageSelector } from '@fourthwall/utils/dist/selectors'
import { useMutation } from '@tanstack/react-query'

export const useCreateWelcomePostsMutation = () => {
  const createWelcomePostsMutation = useMutation({
    mutationFn: async (payload: CreateWelcomePostsPayload) => {
      const { data } = await MembershipsCreatorApiClient.createWelcomePosts(payload)

      return data
    },
    onError: (error: ApiError) => {
      const errorMessage = errorMessageSelector(error.response?.data)

      Toasts.notify(errorMessage, { type: 'error' })
    },
  })

  return { createWelcomePostsMutation }
}
